import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { ErrorScreen, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import styles from './Settings.Styles';
import SettingsLoading from './SettingsLoading';

const renderError = (error, onTryAgainPress) => {
  return (
    <View style={styles.errorScreenContainer}>
      <ErrorScreen
        text={error?.message}
        style={styles.fullScreenError}
        iconStyle={styles.errorIconStyle}
        onPress={onTryAgainPress}
      />
    </View>
  );
};
const renderContent = (error, onTryAgainPress) => {
  if (error) {
    return renderError(error, onTryAgainPress);
  } else {
    return <></>;
  }
};
const Settings = ({ isLoading, error, onTryAgainPress }) => {
  const theme = useTheme();

  return isLoading ? (
    <SettingsLoading theme={theme} />
  ) : (
    <View style={styles.containerStyle}>
      <View>
        <VFText
          i18nKey="soho_business_overview_settings_tab_header_title"
          style={styles.headerTitle(theme)}
        />
      </View>
      {renderContent(error, onTryAgainPress)}
    </View>
  );
};
Settings.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.object.isRequired,
  onTryAgainPress: PropTypes.func,
};
export default Settings;
